var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.66659V13.3333H2.66671V2.66659H13.3334ZM14.6667 1.33325H1.33337V14.6666H14.6667V1.33325ZM8.00004 3.99992C5.79337 3.99992 4.00004 5.79325 4.00004 7.99992C4.00004 10.2066 5.79337 11.9999 8.00004 11.9999C10.2067 11.9999 12 10.2066 12 7.99992C12 5.79325 10.2067 3.99992 8.00004 3.99992Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeg);
export default __webpack_public_path__ + "static/media/veg.e3db99356fb546b87edc8fe62bed9a44.svg";
export { ForwardRef as ReactComponent };